module.exports = __webpack_public_path__ + "public/img/empty.fa11db8d.svg";